




















































































































































































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import { vxm } from '@/store.vuex';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
@Component({
  name: 'UploadResumeSection',
  components: {
    ProfilePlaceholder,
  },
})
export default class UploadResumeSection extends Mixins(GuidedSignupUtilities) {
  @Prop() showUploadText;
  @Prop() toggleShowUploadText;
  @Prop() selectFromDropbox;
  @Prop() validateFileFormate;
  @Prop() resumePayload;
  @Prop() uploadResume;
  @Prop() ResumeListing;
  @Prop() resumeAvailable;

  get allowedFormats() {
    const array = vxm.configs
      .getGlobalConfigValue('ALLOWED_RESUME_FORMATS')
      .split(',');
    console.log('allowedFormats().......', array);
    return vxm.utility.commaAndSeparator(array);
  }

  get allowedResumeFormat() {
    const allowedFormatsString = vxm.configs.getGlobalConfigValue('ALLOWED_RESUME_FORMATS');
    const allowedFormatsArray = allowedFormatsString.split(',');
      return allowedFormatsArray.map(format => format.trim());
  }


  get isDropboxEnabled() {
    if (
      vxm.configs.getGlobalConfigBooelanValue('WL_DROPBOX_INTEGRATION_ENABLED')
    ) {
      if (vxm.configs.getGlobalConfigValue('DROPBOX_APP_KEY')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  userPermissionConfig(permission) {
    return vxm.configs.getUserPermissionConfig(permission, 'RESUME');
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'RESUME',
      );
      return section ? section.displayName : 'Resumes';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'RESUME',
    );
    return section ? section.displayName : 'Resumes';
  }
}
